import { BookOutlined, DownOutlined, EditOutlined } from '@ant-design/icons'
import { Dropdown, Menu, MenuProps, Tooltip, Typography } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Favorite, getPointPermission, MosaicComponent, UserName } from '@/components'
import { HotResource } from '@/components/hot-resource/hot-resource.component'
import { PAGE_RESOURCE_POINTS_ENUM, ResourceType } from '@/schemas'

import { Customer, CustomerFlowStatus } from '../../customer.schema'
import { CustomerEdit } from '../../customer-edit.component'

interface ProjectHeaderContainerProps {
  project: Customer
  refreshProject: () => void
}

export const CustomerHeaderContainer: React.FC<ProjectHeaderContainerProps> = ({
  project: customer,
  refreshProject,
}) => {
  const { t } = useTranslation()

  const translateMap = {
    [CustomerFlowStatus.待研发审批]: t(`customer.flowStatus.${CustomerFlowStatus.待研发审批}.title`),
    [CustomerFlowStatus.研发未开始]: t(`customer.flowStatus.${CustomerFlowStatus.研发未开始}.title`),
    [CustomerFlowStatus.项目已驳回]: t(`customer.flowStatus.${CustomerFlowStatus.项目已驳回}.title`),
    [CustomerFlowStatus.研发进行中]: t(`customer.flowStatus.${CustomerFlowStatus.研发进行中}.title`),
    [CustomerFlowStatus.研发暂停中]: t(`customer.flowStatus.${CustomerFlowStatus.研发暂停中}.title`),
    [CustomerFlowStatus.项目已取消]: t(`customer.flowStatus.${CustomerFlowStatus.项目已取消}.title`),
    [CustomerFlowStatus.待客户验收]: t(`customer.flowStatus.${CustomerFlowStatus.待客户验收}.title`),
    [CustomerFlowStatus.结果追踪中]: t(`customer.flowStatus.${CustomerFlowStatus.结果追踪中}.title`),
    [CustomerFlowStatus.结果复核中]: t(`customer.flowStatus.${CustomerFlowStatus.结果复核中}.title`),
    [CustomerFlowStatus.待项目结项]: t(`customer.flowStatus.${CustomerFlowStatus.待项目结项}.title`),
    [CustomerFlowStatus.项目已结项]: t(`customer.flowStatus.${CustomerFlowStatus.项目已结项}.title`),
    [CustomerFlowStatus.项目已失败]: t(`customer.flowStatus.${CustomerFlowStatus.项目已失败}.title`),
  }

  const [visible, setVisible] = React.useState(false)

  const [editVisible, setEditVisible] = React.useState(false)

  const onClickMenu: MenuProps['onClick'] = ({ key }) => {
    if (key === 'edit') {
      setEditVisible(true)
      setVisible(false)
    }
  }

  const menu = (
    <Menu onClick={onClickMenu}>
      <Menu.Item
        key='edit'
        icon={<EditOutlined />}
        disabled={!getPointPermission(PAGE_RESOURCE_POINTS_ENUM.概况, customer.permissions).canUpdate}
      >
        {t('customer.editInfo')}
      </Menu.Item>
    </Menu>
  )

  return (
    <div className='flex space-x-16px text-sm items-baseline max-w-full truncate'>
      <div>
        <BookOutlined style={{ fontSize: 18 }} />
      </div>
      <Dropdown trigger={['click']} overlay={menu} visible={visible} onVisibleChange={(visible) => setVisible(visible)}>
        <Typography.Text ellipsis className='cursor-pointer text-xl'>
          {customer.name}
          <DownOutlined className='ml-4px' />
        </Typography.Text>
      </Dropdown>
      <div>
        <HotResource selfId={customer.selfId} type={customer.type} />
      </div>
      <div>
        <Favorite selfId={customer.selfId} type={ResourceType.CUSTOMER} isFavourited={customer.isFavourited} />
      </div>
      <div className='h-4 text-sm px-1'>
        {getPointPermission(PAGE_RESOURCE_POINTS_ENUM.概况_状态, customer.permissions).canRead ? (
          translateMap[customer.flowStatus]
        ) : (
          <MosaicComponent />
        )}
      </div>
      <Tooltip title={t('owner')}>
        <div>
          {!getPointPermission(PAGE_RESOURCE_POINTS_ENUM.概况_负责人, customer.permissions).canRead ? (
            <MosaicComponent />
          ) : (
            <UserName email={customer.email} />
          )}
        </div>
      </Tooltip>
      <CustomerEdit
        customer={customer}
        visible={editVisible}
        onCancel={() => {
          setEditVisible(false)
          refreshProject()
        }}
      />
    </div>
  )
}
